import React from "react";
import { Button, Col, Form, Input, Layout, message, Row } from "antd";
import { useForm } from "antd/es/form/Form";
import { useTranslation } from "react-i18next";
import { useForgotPasswordMutation } from "../graphql/generated/hooks";

function ForgotPassword() {
  const { t } = useTranslation();
  const [messageApi, contextHolder] = message.useMessage();
  const [form] = useForm();
  const [forgotPassword, { loading }] = useForgotPasswordMutation();

  const onFinish = async (values: any) => {
    await forgotPassword({
      variables: {
        email: values.email,
      },
    }).then((res) => {
      messageApi.success(
        t("message.success.forgot_password") + " " + res.data?.forgotPassword
      );
    });
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Row>
        <Col xl={4} offset={10} style={{ marginTop: 50 }}>
          {contextHolder}
          <Form
            form={form}
            onFinish={onFinish}
            layout="vertical"
            style={{ marginTop: "20px" }}
          >
            <Form.Item
              rules={[
                { required: true, message: t("message.error.field_required") },
                { type: "email", message: t("message.error.invalid_email") },
              ]}
              hasFeedback
              name="email"
              label={t("label.email")}
            >
              <Input />
            </Form.Item>
            <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
              <Button loading={loading} type="primary" htmlType="submit">
                {t("button.send")}
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </Layout>
  );
}

export default ForgotPassword;
